import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import LayoutPage from '@/views/layout/layout-index';
import HomePage from '@/views/HomeManage/home-index';
import Homes from '@/views/home';
import Welcome from '@/views/welcome';
import demos from '@/views/demos';
import Login from '@/views/login';
import Register from '@/views/register';

import SearchPage from '@/views/search/search-index';
import PalletPage from '@/views/pallet/pallet-index';
import AnalysisPage from '@/views/pallet/pallet-analysis';
import PalletaboutPage from '@/views/pallet/pallet-about';
import PalletMallPage from '@/views/pallet/pallet-mall';//托盘商城
import PalletMallDetail from '@/views/pallet/pallet-mall-detail';//托盘商城
import NewDetail from '@/views/secondary/secondary-new-details'; //新闻详情
import MatchingAnalysis from '@/views/secondary/matching-analysis'; //撮合交易分析
import MatchingExpertsD from '@/views/secondary/secondary-experts-detail'; //行业专家列表
import MatchingExpertsL from '@/views/secondary/secondary-experts-list'; //行业专家列表
import RiseFallList from '@/views/secondary/rise-fall-list'; //涨跌榜
import CloudLive from '@/views/secondary/secondary-cloudlive-list'; //云直播
import IndustryStandard from '@/views/secondary/secondary-industrystandard-list'; //行业标准
import IndustryKnowledge from '@/views/secondary/secondary-Industryknowledge-list'; //行业知识
import IndustryMap from '@/views/secondary/secondary-Industrymap-list'; //行业图谱
import IndustryMapD from '@/views/secondary/secondary-industrymap-details'; //行业图谱详情
import Exhibition from '@/views/secondary/secondary-exhibition-list'; //展会
import CloudMall from '@/views/secondary/secondary-cloudmall-details'; //云商城
import SentimentAnalysis from '@/views/secondary/sentiment-analysis'; //quickbi 图表
import IndexProsperity from '@/views/secondary/index-prosperity'; //景气指数
import IndustryCustom from '@/views/secondary/secondary-industrycustom-list'; //云定制
import OverviewAnalysis from '@/views/secondary/overview-analysis'; //化纤总览
import Industrial from '@/views/secondary/secondary-industrial-list'; //工业app
import Infotom from '@/views/secondary/secondary-new-Infotom'; //信息通
import StorageVideo from '@/views/secondary/storage-video'; //仓储云眸
import NewSmart from '@/views/secondary/new-smart-list'; //新智造
import NewSmartD from '@/views/secondary/new-smart-detail'; //新智造详情
import ProductionAlarmAnalysis from '@/views/secondary/production-alarm-analysis'; //生产预警预报app应用分析
import ProductionAlarmAnalysis2 from '@/views/secondary/production-alarm-analysis2'; //生产预警预报app应用分析
import ProductionAlarmAnalysis3 from '@/views/secondary/production-alarm-analysis3'; //生产预警预报app应用分析
import ProductionAlarmAnalysis4 from '@/views/secondary/production-alarm-analysis4'; //生产预警预报app应用分析
import Indunowledgedetails from '@/views/secondary/secondary-indunowledge-details'; //行业标准和行业知识的详情页
import Printingdyeing from '@/views/secondary/printing-dyeing-analysis'; //印染分析
import Pdworkshop from '@/views/Ld-screen/Pd-workshop'; //印染车间
import Pkworkshop from '@/views/Ld-screen/Pk-workshop'; //塑编车间
import Textileworkshop from '@/views/Ld-screen/textile-workshop'; //纺织厂
import Spinningworkshop from '@/views/Ld-screen/spinning-workshop'; //纺丝车间
import IndexMacro from '@/views/secondary/indexmacro'; //化纤指数
import PropagandaHxzl from '@/views/secondary/propaganda-hxzl'; //宣传页
import Propaganda from '@/views/secondary/propaganda'; //宣传轮播
import pageSize from '@/views/getPageSize'; //获取页面大小
import ale from '@/views/ale'; // 阿拉尔大屏
import KnowledgeCenter from '@/views/knowledge-center'; // 化纤行业知识中心（GEO 试点）
import userrouter from './user'
import etlrouter from './etl'

Vue.use(Router)

// 兼容历史 hash 链接：将 /#/xxx 重定向为干净的 history 路径 /xxx
// （站点已切换为 history 模式，旧的 #/ 链接、外部书签、分享链接均可正确落地）
;(function () {
  var h = window.location.hash
  if (h && h.indexOf('#/') === 0) {
    window.location.replace(h.slice(1) + window.location.search)
  }
})()

const indexrouter=[
  // {
  //   path: '/',
  //   name: 'HelloWorld',
  //   component: HelloWorld
  // },
  {
    path: '/',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/one',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/xzzs',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/jjfas',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/xwzx',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/xqhz',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/about',
    name: 'Home',
    component: Homes,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/Christmas',
    name: 'Christmas',
    component: demos,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      keepAlive: false,
      title: '化学纤维产业-登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      keepAlive: false,
      title: '化学纤维产业-注册'
    }
  },
  {
    path: '/HomePage',
    name: 'HomePage',
    component: HomePage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: SearchPage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/pallet',
    name: 'Pallet',
    component: PalletPage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/palletanalysis',
    name: 'palletAnalysis',
    component: AnalysisPage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/palletabout',
    name: 'palletabout',
    component: PalletaboutPage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/palletmall',
    name: 'PalletMallPage',
    component: PalletMallPage,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newdetail',
    name: 'newdetail',
    component: NewDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/matching',
    name: 'MatchingAnalysis',
    component: MatchingAnalysis,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/experts',
    name: 'MatchingExpertsL',
    component: MatchingExpertsL,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/expertd',
    name: 'MatchingExpertsD',
    component: MatchingExpertsD,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/risefall',
    name: 'RiseFallList',
    component: RiseFallList,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/cloudlive',
    name: 'CloudLive',
    component: CloudLive,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/industrystandard',
    name: 'IndustryStandard',
    component: IndustryStandard,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/industryknowledge',
    name: 'IndustryKnowledge',
    component: IndustryKnowledge,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/knowledge-center',
    name: 'KnowledgeCenter',
    component: KnowledgeCenter,
    meta: {
      keepAlive: false,
      title: '化纤行业知识中心'
    }
  },
  {
    path: '/knowledge-center/:slug',
    name: 'KnowledgeTopic',
    component: KnowledgeCenter,
    meta: {
      keepAlive: false,
      title: '化纤行业知识中心'
    }
  },
  {
    path: '/industrymap',
    name: 'IndustryMap',
    component: IndustryMap,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/industrymapd',
    name: 'IndustryMapD',
    component: IndustryMapD,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/exhibition',
    name: 'Exhibition',
    component: Exhibition,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/cloudmall',
    name: 'CloudMall',
    component: CloudMall,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/sentiment',
    name: 'SentimentAnalysis',
    component: SentimentAnalysis,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/custom',
    name: 'IndustryCustom',
    component: IndustryCustom,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/overview',
    name: 'OverviewAnalysis',
    component: OverviewAnalysis,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/industrial',
    name: 'Industrial',
    component: Industrial,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/infotom',
    name: 'Infotom',
    component: Infotom,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/malldetail',
    name: 'PalletMallDetail',
    component: PalletMallDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/storagevideo',
    name: 'StorageVideo',
    component: StorageVideo,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/newsmart',
    name: 'NewSmart',
    component: NewSmart,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newsmartdetail',
    name: 'NewSmartD',
    component: NewSmartD,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/productionalarm',
    name: 'ProductionAlarmAnalysis',
    component: ProductionAlarmAnalysis,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/productionalarm2',
    name: 'ProductionAlarmAnalysis2',
    component: ProductionAlarmAnalysis2,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/productionalarm3',
    name: 'ProductionAlarmAnalysis3',
    component: ProductionAlarmAnalysis3,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/productionalarm4',
    name: 'ProductionAlarmAnalysis4',
    component: ProductionAlarmAnalysis4,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/indunowledgedetails',
    name: 'Indunowledgedetails',
    component: Indunowledgedetails,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/Printingdyeing',
    name: 'Printingdyeing',
    component: Printingdyeing,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/Pdworkshop',
    name: 'Pdworkshop',
    component: Pdworkshop,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/Pkworkshop',
    name: 'Pkworkshop',
    component: Pkworkshop,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/textile',
    name: 'textileworkshop',
    component: Textileworkshop,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/spinning',
    name: 'spinningworkshop',
    component: Spinningworkshop,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/prosperity',
    name: 'prosperity',
    component: IndexProsperity,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/indexmacro',
    name: 'indexmacro',
    component: IndexMacro,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/hxzl',
    name: 'hxzl',
    component: PropagandaHxzl,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/Propaganda',
    name: 'Propaganda',
    component: Propaganda,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/pageSize',
    name: 'pageSize',
    component: pageSize,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/ale',
    name: 'ale',
    component: ale,
    meta: {
      keepAlive: false,
      title: '阿拉尔化纤数据大屏'
    }
  }
]

export default new Router({
  mode: 'history',
  routes: [...indexrouter, ...userrouter, ...etlrouter]
})



// WEBPACK FOOTER //
// ./src/router/index.js